import React, {useContext, useEffect, useState} from 'react'
import {PurchaseContext} from "../../../context/PurchaseContext";
import {Table} from "antd";


const TaxTotal = () => {
    const {memoizeTaxCurrencyTotals, memoizeCurrencyTotals, taxes} = useContext(PurchaseContext)
    const [taxList] = taxes
    const [currencyState, setCurrencyState] = useState([])
    const [columns, setColumns] = useState([])
    const [tableData, setTableData] = useState([])

    useEffect(() => {
        setCurrencyState(memoizeTaxCurrencyTotals);
        getColumnsForTaxCostTable()
        calcEachTaxCost()
    }, [memoizeTaxCurrencyTotals, taxList])

    const getColumnsForTaxCostTable = () => {
        const mockColumns = [{title: 'Para Birimi', dataIndex: 'currency'}]
        taxList.map(item => mockColumns.push({title: item.taxName, dataIndex: `tax-amount-${item.taxName}`}))
        setColumns(mockColumns)
    }

    const calcEachTaxCost = () => {
        const mockRows = []
        Object.keys(memoizeCurrencyTotals).map((key, idx) => {
            const currencyItem = memoizeCurrencyTotals[key].reduce((a, b) => a + b, 0)
            if (currencyItem) {
                const currencyTaxesObj = {}
                currencyTaxesObj.currency = key
                currencyTaxesObj.key = `${key}-${idx}`
                taxList.map(taxItem => {
                    currencyTaxesObj[`tax-amount-${taxItem.taxName}`] = (currencyItem * taxItem.taxRatio) / 100
                })
                mockRows.push(currencyTaxesObj)
            }
        })
        setTableData(mockRows)
    }

    return (
        <React.Fragment>
            <div style={{margin: '32px 0'}}>
                <h4>Maliyet Tablosu</h4>
            </div>
            <div>
                <Table pagination={false} columns={columns} dataSource={tableData}/>
            </div>
            <div>
                {
                    Object.keys(currencyState).map(key => {
                        const item = currencyState[key]
                        if (item > 0) {
                            return (
                                <p key={key}>
                                    <span className={'font-bold'}> Vergiler Dahil Toplam {key}: </span>
                                    {new Intl.NumberFormat().format(currencyState[key])}
                                </p>
                            )
                        }
                    })
                }
            </div>
        </React.Fragment>
    )
}
export default TaxTotal